import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { DamageRecentYears } from "./recentDamagesInterfaces";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getInjuriesSchema = (
  injuriesBreaking?: string,
  injuries?: string,
  injuryYear?: string,
) => {
  const { getText } = TextManager;

  return Yup.object({
    injuries: Yup.mixed<DamageRecentYears>()
      .required(
        injuries ?? getText("recentdamages.validation.injuries-required"),
      )
      .notOneOf(
        [DamageRecentYears.TWO_OR_MORE],
        ErrorPrefix.BREAKING +
          (injuriesBreaking ??
            getText("recentdamages.validation.injuries-maxdamages")),
      ),
    injuryYear: Yup.string().when("injuries", {
      is: (value: DamageRecentYears) => value === DamageRecentYears.ONE,
      then: (schema) =>
        schema.required(
          injuryYear ?? getText("recentdamages.validation.injuryyear"),
        ),
    }),
  });
};
